import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const usePageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    const titles = {
      '/': 'Estoque',
      '/cadastrar/produto/': 'Cadastrar | Produto',
      '/cadastrar/categoria/': 'Cadastrar | Marcas',
      '/cadastrar/maquinario/': 'Cadastrar | Maquinario',
      '/cadastrar/equipamento/peca': 'Cadastrar | Equipamento - Peças',
      '/arvore-pe%C3%A7as': 'Arvore de peças',
      '/registrar/entradas/': 'Registrar | Entrada',
      '/registrar/saidas/': 'Registrar | Saida',
      '/historico/saida/': 'Historico | Saida',
      '/historico/entradas': 'Historico | Entrada',
      '/cadastroCsv/': 'Importa CSV',
      '/compras/': 'Compras do estoque',
      '/login': 'Duarts.dev',
      '/funcionarios/': 'Controle de funcionario',
    };
    document.title = `${titles[location.pathname]} ` || 'Meu App';
  }, [location.pathname]);
};

export default usePageTitle;
